<template>
  <AcceptingDialog
    ref="accepting_dialog"
    :acceptors="acceptors_after_me"
    :btn_text="$t('Tenders.ToAgree')"
    :card_text="!acceptors_after_me.length ? $t('Tenders.PublishedText') : ''"
    data-qa="tender-Egreement"
    :disabled_open="loading == 'reject'"
    :loading="loading == 'resolve'"
    :send-action="open"
    :title="title"
    :without_accept="!acceptors_after_me.length"/>
</template>

<script>
import AcceptingDialog from 'components/common/dialogs/AcceptingDialog.vue'

export default {
  name: 'tenderEgreement',
  data() {
    return {
      dialog: false,
      options: {}
    }
  },
  props: {
    tender: Object,
    loading: [Boolean, String],
    acceptors: Array,
    callback: Function,
  },
  computed: {
    title() {
      return this.$t( !this.acceptors_after_me.length ? 'Tenders.SuccessfullyPublished' : 'Tenders.SuccessfullyApproved',
        {number: this.tender.tenderNumber })
    },
    me_accept_index() {
      return this.acceptors?.findIndex(el => el.isMy && el.status == 'WAITING')
    },
    acceptors_after_me() {
      return this.acceptors?.slice(this.me_accept_index + 1)
    },
  },
  methods: {
    async open() {
      await this.callback().then(() => {
        this.$refs.accepting_dialog?.open()
      })
    },
  },
  components: {
    AcceptingDialog
  }
}
</script>
